import { createTheme } from "@mui/material/styles";
import {
  theme as baseTheme,
  CALIBRATE_FONT_FAMILY_ACCENT,
} from "components/hoc/Theme";

/**
 * Calibrate management look layered on the global theme: Montserrat
 * everywhere, uppercase buttons and uppercase table header micro-labels.
 * Extracted verbatim from the Client & User Setup page-local theme so every
 * management page shares one source of truth.
 */
export const managementTheme = createTheme(baseTheme, {
  typography: {
    fontFamily: CALIBRATE_FONT_FAMILY_ACCENT,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "uppercase" as const,
          letterSpacing: "0.06em",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          textTransform: "uppercase" as const,
          fontSize: 11,
          letterSpacing: "0.07em",
          fontWeight: 700,
          fontFamily: CALIBRATE_FONT_FAMILY_ACCENT,
        },
      },
    },
  },
});

/** Tab-bar styling shared by management pages (uppercase 12px tabs). */
export const MANAGEMENT_TABS_SX = {
  "& .MuiTab-root": {
    textTransform: "uppercase",
    fontWeight: 700,
    minHeight: 44,
    fontSize: 12,
    letterSpacing: "0.06em",
  },
  "& .MuiTab-root.Mui-selected": {
    color: "calibrate.accentOrange",
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "calibrate.accentOrange",
  },
} as const;

/**
 * Phones: each tab takes an equal share of the row and its label may wrap, so
 * no tab is cut off behind a scroll edge. Pair with `variant="fullWidth"`.
 */
export const MANAGEMENT_TABS_FULL_WIDTH_SX = {
  "& .MuiTab-root": {
    minWidth: 0,
    px: 0.75,
    lineHeight: 1.3,
    whiteSpace: "normal",
  },
} as const;

/** Inner bordered content area (tables) inside the white panel. */
export const MANAGEMENT_TABLE_AREA_SX = {
  position: "relative",
  display: "flex",
  flex: 1,
  minHeight: 0,
  borderRadius: 1,
  border: "1px solid",
  borderColor: "divider",
  overflow: "hidden",
} as const;
